//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "page-tabs",
    data() {
        return {
        }
    },
    computed: {
        pageTabs() {
            return this.$store.state.pageTabs;
        },
        pageTabValue: {
            get() {
                return this.$store.state.pageTabValue;
            },
            set(val) {
                this.$store.state.pageTabValue = val;
            }
        }
    },
    methods: {
        isClosable(name) {
            let isClosable = true;
            // if(name === "首页") {
            //     isClosable = false;
            // }
            return isClosable;
        },
        removeTab(targetName) {
            let tabs = this.pageTabs,
                activeName = this.pageTabValue,
                activeTab; 

            for(let i=0, len=tabs.length; i<len; i++) {
                if (tabs[i].name === targetName) {
                    let nextTab,
                        nexTabIndex;

                    if(tabs[i + 1]) {
                        nextTab = tabs[i + 1];
                        nexTabIndex = i + 1;
                    } else if(tabs[i - 1]) {
                        nextTab = tabs[i - 1];
                        nexTabIndex = i - 1;
                    }

                    // 设置高亮的 tab
                    if (nextTab) {
                        activeName = nextTab.name;
                        activeTab = tabs[nexTabIndex];
                    } else {
                        activeName = tabs[i].name;
                    }

                    break;
                }
            }
            
            activeTab && this.clickTab(activeTab);
            this.$store.dispatch("changePageTabValue", activeName);
            this.$store.dispatch("delPageTab", targetName);
        },
        clickTab(tab) {
            let path,
                tabsArr = this.pageTabs;
            for(let v of tabsArr) {
                if(v.name === tab.name) {
                    path = v.path;
                    break;
                }
            }
            this.$router.push(path);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pccomponents/PageTabs.vue